

import React, { useEffect } from "react";
import SelectOption from "components/common/Select/Select";
import { RECURRING_INTERVAL } from "store/constants";
import CheckboxWithLabel from "components/common/CheckboxWithLabel";
import moment from "moment";

const RecurringShift = ({
  setRecurringType,
  recurringType,
  watchFormData,
  setRecurrInterval,
  recurrInterval,
  setRecurringDates,
  setSelectedDays,
  selectedDays,
  selectedShift,
  setRecurringFor,
  recurringFor,
  handleIntervalChange,
  shiftDetailData,
  setLoading,
}) => {
  useEffect(() => {
    if (selectedShift !== null && shiftDetailData?.recurring_days) {
      const parsedDays = JSON.parse(shiftDetailData?.recurring_days);
      const formattedDays = {
        mon: parsedDays.monday,
        tue: parsedDays.tuesday,
        wed: parsedDays.wednesday,
        thu: parsedDays.thursday,
        fri: parsedDays.friday,
        sat: parsedDays.saturday,
        sun: parsedDays.sunday,
      };

      if (formattedDays) {
        setSelectedDays(formattedDays);
      }
    }
  }, [
    watchFormData?.shift_date,
    recurrInterval,
    recurringType,
    selectedShift,
    setSelectedDays,
    shiftDetailData,
  ]);
  useEffect(() => {
    if (watchFormData?.shift_date && selectedShift === null) {
      const shiftDate = moment(watchFormData.shift_date);
      const dayName = shiftDate.format("ddd");
      setSelectedDays((prevSelectedDays) => ({
        ...prevSelectedDays,
        [dayName]: true,
      }));
    }
  }, [
    watchFormData?.shift_date,
    recurrInterval,
    recurringType,
    selectedShift,
    setSelectedDays,
  ]);

  const getWeekOfMonth = (date) => {
    const firstDayOfMonth = date.clone().startOf("month");
    return Math.ceil((date.date() + firstDayOfMonth.day()) / 7);
  };

 
  useEffect(() => {
    if (recurringType) {
      // const shiftDate = moment(watchFormData?.shift_date).add(1, "month"); // Start from the next month

      const number = parseInt(recurringType.value.split("_")[0]);
      const label = recurringType.value.split("_")[1];

      const formattedDates = [];

      if (label === "Fortnight") {
        const shiftDate = moment(watchFormData?.shift_date);
        const initialDate = shiftDate.clone().add(7, "days");

        for (let period = 1; period <= number; period++) {
          const startOfSecondWeek = initialDate
            .clone()
            .add(period * 14 - 7, "days");

          for (let dayOffset = 0; dayOffset < 7; dayOffset++) {
            const currentDate = startOfSecondWeek
              .clone()
              .add(dayOffset, "days");
            const dayName = currentDate.format("ddd");

            if (selectedDays[dayName]) {
              formattedDates.push(
                currentDate.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
              );
            }
          }
        }
      } else if (label === "Month") {


        const shiftDate = moment(watchFormData?.shift_date);
    const initialWeekOfMonth = getWeekOfMonth(shiftDate); // Determine the week position of the initial shift date

    for (let monthIndex = 1; monthIndex <= number; monthIndex++) {
        const currentMonth = shiftDate.clone().add(monthIndex, "months");
        
        // Calculate the target week for each selected day within the same month
        let targetWeekStart = currentMonth.clone().startOf("month").add((initialWeekOfMonth - 1) * 7, "days");

        // Adjust if the target week goes beyond the end of the month
        const endOfMonth = currentMonth.clone().endOf("month");
        if (targetWeekStart.isAfter(endOfMonth)) {
            // Move to the last week within the month
            targetWeekStart = endOfMonth.clone().subtract(6, "days").startOf("week");
        }

        // Loop through each selected day in the week
        for (const [day, isSelected] of Object.entries(selectedDays)) {
            if (!isSelected) continue;  // Skip unselected days

            let foundDate = null;

            // Try to find the specified day within the target week
            for (let dayOffset = 0; dayOffset < 7; dayOffset++) {
                const currentDate = targetWeekStart.clone().add(dayOffset, "days");
                const dayName = currentDate.format("ddd");

                if (dayName === day) {
                    foundDate = currentDate;
                    break;
                }
            }

            // If the day isn't found in the target week, find the last occurrence within the month
            if (!foundDate || !foundDate?.isSame(currentMonth, 'month')) {
                foundDate = null;
                for (let dayOffset = 0; dayOffset <= endOfMonth.date(); dayOffset++) {
                    const currentDate = endOfMonth.clone().subtract(dayOffset, "days");
                    const dayName = currentDate.format("ddd");

                    if (dayName === day) {
                        foundDate = currentDate;
                        break;
                    }
                }
            }

            // Add the found date to formattedDates, now ensured to be within the target month and week position
            if (foundDate) {
                formattedDates?.push(foundDate.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"));
            }
        }
    }
       
      } else {
 
        const shiftDate = moment(watchFormData?.shift_date);

        const intervalFactor = 7;
        // const initialDate = shiftDate.clone().add(7, "days");
        for (let i = 0; i < number * intervalFactor; i++) {
          const currentDate = shiftDate.clone().add(i, "days");
          const dayName = currentDate.format("ddd");
          if (selectedDays[dayName]) {
            formattedDates.push(
              currentDate?.format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")
            );
          }
        }
      }

      setRecurringDates(formattedDates);
    }
  }, [
    recurringType,
    watchFormData?.shift_date,
    selectedDays,
    setRecurringDates,
  ]);

  return (
    <div>
      <div className='flex flex-col gap-2 mt-2'>
        <div className='w-full'>
          <label className='text-gray-700 text-xs font-medium mb-1 block'>
            Interval
          </label>
          <div
            onMouseDown={(e) => {
              // Prevent form submission when clicking dropdown control
              const target = e.target;
              if (target.closest('[class*="css-"][class*="control"]') || 
                  target.closest('.select-basic-single') ||
                  target.closest('.roleSelector')) {
                if (!target.closest('[class*="menu"]')) {
                  e.stopPropagation();
                }
              }
            }}
          >
            <SelectOption
              data={RECURRING_INTERVAL}
              placeHolder='Select interval'
              selectedOption={recurrInterval}
              handleChange={handleIntervalChange}
              isSearch={false}
              cssClass='z-8 select-text-xs'
              isDisabled={selectedShift !== null}
              newDesign={true}
            />
          </div>
        </div>
        <div className='w-full'>
          <label className='text-gray-700 text-xs font-medium mb-1 block'>
            Repeat for
          </label>
          <div
            onMouseDown={(e) => {
              // Prevent form submission when clicking dropdown control
              const target = e.target;
              if (target.closest('[class*="css-"][class*="control"]') || 
                  target.closest('.select-basic-single') ||
                  target.closest('.roleSelector')) {
                if (!target.closest('[class*="menu"]')) {
                  e.stopPropagation();
                }
              }
            }}
          >
            <SelectOption
              data={recurringFor || []}
              placeHolder='Select number'
              selectedOption={recurringType}
              handleChange={(e) => {
                setRecurringType(e);
              }}
              isSearch={false}
              cssClass='z-8 select-text-xs'
              isDisabled={selectedShift !== null}
              newDesign={true}
            />
          </div>
        </div>
      </div>
      {watchFormData?.is_recurring && recurringType && (
        <div className='mt-3'>
          <label className='text-gray-700 text-xs font-medium mb-1.5 block'>
            Select days
          </label>
          <div className='grid grid-cols-2 gap-1.5 mt-1'>
            {Object.entries(selectedDays)?.map(([day, isSelected]) => (
              <CheckboxWithLabel
                key={day}
                label={day}
                checkboxId={day}
                checked={isSelected}
                setSelectedDays={setSelectedDays}
                disabled={selectedShift !== null}
                cssClass='text-xs py-1 px-2 w-full justify-between'
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default RecurringShift;
